import { React, useEffect } from 'react'
import { initCWTracks } from '../../../cw_center/init-cwtracks'
import { store } from '../../../redux/store'
import { setInitCWTracksState } from '../../../redux/actions/getAppPublicData'

export const CWTracksProvider = () => {

    useEffect(() => {
        store.subscribe(() => {
            const _store = store.getState().public;
            
            if (_store.shopDomain && !Boolean(_store.setInitCWTracks)) {
                initCWTracks(_store.shopDomain, `${_store.created_at}`);
                store.dispatch(setInitCWTracksState(true)); // 设置已初始化CWTracks
            }
        })
    }, [])
    
    return <></>
}